module.exports = __webpack_public_path__ + "img/commercieel@2x.1f92364f.png";